import { combineReducers } from 'redux';

import { reducer as valuations } from './State/valuations';
import { reducer as valuationTotals } from './State/valuationTotals';
import { reducer as pagination } from './State/pagination';
import { reducer as searchTerm } from './State/searchTerms';
import { reducer as fetching } from './State/fetching';
import { reducer as filters } from './State/filters';
import { reducer as sorting } from './State/sorting';
import { reducer as showValuationModal } from './State/showValuationModal';

export default combineReducers({

  valuations,
  valuationTotals,
  pagination,
  searchTerm,
  fetching,
  filters,
  sorting,
  showValuationModal
  
})
